import Api, { handleError } from '@/services/Api';


// const API_URL = 'http://localhost:8000/api';
const API_URL = process.env.API_BASE;

export async function getAllSetting() {
  const url = `${API_URL}/settings/`;
  const { status, data } = await Api.get(url).catch(handleError);

  return { status, data };
}

export async function editPlanSetting(setting) {
  const url = `${API_URL}/settings/edit_plan_setting/`;
  const { status, data } = await Api.put(url, setting).catch(handleError);

  return { status, data };
}

export async function planSetting() {
  const url = `${API_URL}/settings/plan_setting/`;
  const { status, data } = await Api.get(url).catch(handleError);

  return { status, data };
}

export async function ChatConfig() {
  const url = `${API_URL}/settings/chat_config/`;
  const { status, data } = await Api.get(url).catch(handleError);

  return { status, data };
}

export async function languageSetting() {
  const url = `${API_URL}/settings/language_setting/`;
  const { status, data } = await Api.get(url).catch(handleError);

  return { status, data };
}

export async function editChatConfig(setting) {
  const url = `${API_URL}/settings/chat_config/`;
  const { status, data } = await Api.put(url, setting).catch(handleError);

  return { status, data };
}

export async function getLanguage() {
  const url = `${API_URL}/languages/`;
  const { status, data } = await Api.get(url).catch(handleError);

  return { status, data };
}

export async function amountSetting() {
  const url = `${API_URL}/settings/amount_setting/`;
  const { status, data } = await Api.get(url).catch(handleError);

  return { status, data };
}

export async function maxImageSetting() {
  const url = `${API_URL}/settings/max_image_setting/`;
  const { status, data } = await Api.get(url).catch(handleError);

  return { status, data };
}

export async function listImportantMessagesApi(token = null) {
  const url = `${API_URL}/important-messages/`;

  if (token) {
    const headers = { Authorization: `JWT ${token}` };
    const { status, data } = await Api.get(url, { headers }).catch(handleError);
    return { status, data };
  }

  const { status, data } = await Api.get(url).catch(handleError);
  return { status, data };
}

export async function getImportantMessagesApi(id) {
  const url = `${API_URL}/important-messages/${id}/`;
  const { status, data } = await Api.get(url).catch(handleError);

  return { status, data };
}

export async function createImportantMessagesApi(payload) {
  const url = `${API_URL}/important-messages/create/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function updateImportantMessagesApi(id, payload) {
  const url = `${API_URL}/important-messages/${id}/update/`;
  const { status, data } = await Api.put(url, payload).catch(handleError);
  return { status, data };
}


export async function deleteImportantMessagesApi(id) {
  const url = `${API_URL}/important-messages/${id}/delete/`;
  const { status, data } = await Api.delete(url).catch(handleError);
  return { status, data };
}

export async function readImportantMessagesApi(id, token = null) {
  const url = `${API_URL}/read-important-messages/${id}/`;

  if (token) {
    const headers = { Authorization: `JWT ${token}` };
    const { status, data } = await Api.post(url, {}, { headers }).catch(handleError);
    return { status, data };
  }
  const { status, data } = await Api.post(url).catch(handleError);
  return { status, data };
}

export async function readNoticeMessageApi(payload, token = null) {
  const url = `${API_URL}/already-read/`;

  if (token) {
    const headers = { Authorization: `JWT ${token}` };
    const { status, data } = await Api.post(url, payload, { headers }).catch(handleError);
    return { status, data };
  }
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}
